// extracted by mini-css-extract-plugin
export var box = "_1f-2";
export var checkboxControl = "_1f-0";
export var checkboxRow = "_1f-a";
export var checked = "_1f-3";
export var descriptionSpacer = "_1f-c";
export var disabled = "_1f-4";
export var icon = "_1f-8";
export var input = "_1f-1";
export var labelSpacer = "_1f-b";
export var large = "_1f-7";
export var medium = "_1f-6";
export var small = "_1f-5";
export var text = "_1f-9";